import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { EmployeesService } from './Service/employees.service';
import * as CryptoJS from 'crypto-js';
import { CommonService } from '../../../../shared/common.service';
import { Observable } from 'rxjs';
import { BootstrapToastComponent } from '../../../../demo/ui-elements/ui-basic/toasts/tosts-config/bootstrap.toast';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';

@Component({
  selector: 'app-employees',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.scss']
})
export class EmployeesComponent implements OnInit {

  CreatteEmployeesformGroup: FormGroup;
  isJump; any;
  NormalRoutng: boolean;
  showBubbledata: any;
  empid: any;
  constructor(public FormBuilder: FormBuilder, public EmployeesService: EmployeesService, public Router: Router, public commonService: CommonService, private sidenav: SideNavService) {

  }
  ngOnInit(): void {
    debugger;
    this.commonService.getNotesData();
   // this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.commonService.getNotesData();
    this.isJump = localStorage.getItem('isJump');
    this.CreatteEmployeesform();
      this.gertEmployees();
      this.clearfield();
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.CreatteEmployeesformGroup.controls['APPeriodId'].value).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true)
        this.gertEmployees_LY()
      }
    })

    if (localStorage.getItem("SubmitStatus") == "true")
      this.CreatteEmployeesformGroup.disable()
  
  }


  CreatteEmployeesform() {
    this.CreatteEmployeesformGroup = this.FormBuilder.group({
      EmployeesId: new FormControl(),
      WagesSalaries: new FormControl(null),
      WagesSalaries_LY: new FormControl(),
      SocialSecurityCosts: new FormControl(null),
      SocialSecurityCosts_LY: new FormControl(),
      PensionOtherPostøemploymentBenefitCostsOtherPensionCosts: new FormControl(),
      PensionOtherPostøemploymentBenefitCostsOtherPensionCosts_LY: new FormControl(),
      StaffCostsEmployeeBenefitsExpense: new FormControl({ value: '', disabled: true }),
      StaffCostsEmployeeBenefitsExpense_LY: new FormControl({ value: '', disabled: true }),
      AverageNumberEmployeesDuringPeriod: new FormControl(),
      AverageNumberEmployeesDuringPeriod_LY: new FormControl(),
      EmployeeInformationFreeøtextComment: new FormControl(),
      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),
      CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.CreatteEmployeesformGroup.reset();
        this.CreatteEmployeesformGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
      }
    })
  }

  On_Next() {
    debugger;
    //this.calculations();
    //this.CreatteEmployeesformGroup.
    //this.Router.navigate(['/taxation']);
    if (this.Validationa()) {

      if (this.empid != "" && this.empid!=null)
        this.CreatteEmployeesformGroup.controls["EmployeesId"].setValue(this.empid);

      this.EmployeesService.SaveEmployees(this.CreatteEmployeesformGroup.getRawValue()).subscribe(data => {
        this.CreatteEmployeesformGroup.markAsPristine();
        if (this.NormalRoutng)
          return true;
        var nextPage;
        nextPage = this.commonService.getNextNoteSelection("Employees", this.commonService.NotesList)
        if (this.isJump == 'true')
          this.Router.navigate(['/notes'])
        else if (nextPage == "employees") {
          nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
          this.Router.navigate([nextPage]);
        }
        else {
          this.Router.navigate([nextPage]);
        }
      })
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
      
  }

  On_Back() {
    this.CreatteEmployeesformGroup.markAsPristine();
    debugger;
    localStorage.setItem("Backbutton", "true");
    var backpage = this.commonService.getBackSelection("Employees", this.commonService.NotesList);
    if (this.isJump == 'true') {
      this.Router.navigate(['/notes'])
    }
    else if (backpage == 'employees') {
      this.Router.navigate(['/notes']);
    }
    else {
      backpage = this.commonService.getBackSelection("Employees", this.commonService.NotesList)
      this.Router.navigate([backpage]);
    }
  }

  gertEmployees() {
    debugger;
    this.EmployeesService.GetOneEmployees(this.CreatteEmployeesformGroup.controls['APPeriodId'].value).subscribe((data:any) => {
      this.CreatteEmployeesformGroup.patchValue(data);
      this.empid = data.EmployeesId;
      this.CreatteEmployeesformGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    })
  }
  gertEmployees_LY() {
    debugger;
    this.EmployeesService.GetOneEmployees_LY(this.CreatteEmployeesformGroup.controls['APPeriodId'].value).subscribe(data => {
      this.showBubbledata=data;
      this.CreatteEmployeesformGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    })
  }

  Validationa() {
    debugger;
    //if (this.commonService.showControl == true) {
    //  if (!this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod'].value || this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod'].value == null || !this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod_LY'].value || this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod_LY'].value == null || this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod'].value == "" || this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod_LY'].value == "") {
    //    if (this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod'].value == null || this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod'].value == "" || this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod_LY'].value == null || this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod_LY'].value == "")

    //      //if (!this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod'].value || +this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod'].value == 0 || !this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod_LY'].value || +this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod_LY'].value == 0) {
    //      //  if (+this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod'].value == 0 || +this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod_LY'].value == 0)
    //    {
    //      Swal.fire("Andica Accounts Production", "The notes to a company's annual accounts must disclose the average number of persons employed by the company in the financial year.", "warning")
    //      //Swal.fire({
    //      //  text: "The notes to a company's annual accounts must disclose the average number of persons employed by the company in the financial year.",
    //      //  showConfirmButton: true,
    //      //  icon: 'warning',

    //      //})
    //      return false;
    //    }
    //  }
    //  else
    //    return true
      
    //} //old code 08/05/2025
    if (this.commonService.showControl == true) {
    if (this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod'].value == null || this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod'].value === "" || this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod_LY'].value == null || this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod_LY'].value === "")
      {
        Swal.fire("Andica Accounts Production", "The notes to a company's annual accounts must disclose the average number of persons employed by the company in the financial year.", "warning")
        return false;

      }
      // }

      else
        return true
    }

    else {
      if (this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod'].value == null || this.CreatteEmployeesformGroup.controls['AverageNumberEmployeesDuringPeriod'].value === "") {
        Swal.fire("Andica Accounts Production", "The notes to a company's annual accounts must disclose the average number of persons employed by the company in the financial year.","warning")
        //Swal.fire({
        //  text: "The notes to a company's annual accounts must disclose the average number of persons employed by the company in the financial year.",
        //  showConfirmButton: true,
        //  icon: 'warning',

        //})
        return false;
      }
      else
        return true
    }
  }

  Calculations() {
    debugger;
    var total1 = +this.CreatteEmployeesformGroup.controls['WagesSalaries'].value + +this.CreatteEmployeesformGroup.controls['SocialSecurityCosts'].value + +this.CreatteEmployeesformGroup.controls['PensionOtherPostøemploymentBenefitCostsOtherPensionCosts'].value;
    var total2 = +this.CreatteEmployeesformGroup.controls['WagesSalaries_LY'].value + +this.CreatteEmployeesformGroup.controls['SocialSecurityCosts_LY'].value + +this.CreatteEmployeesformGroup.controls['PensionOtherPostøemploymentBenefitCostsOtherPensionCosts_LY'].value;
    this.CreatteEmployeesformGroup.controls['StaffCostsEmployeeBenefitsExpense'].setValue(total1 == 0 ? '' : total1);
    this.CreatteEmployeesformGroup.controls['StaffCostsEmployeeBenefitsExpense_LY'].setValue(total2 == 0 ? '' : total2);

 
    }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.CreatteEmployeesformGroup.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          debugger;
          this.NormalRoutng = true;
          if (this.On_Next()) {
            return true;
          }
          else if(!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.Router.navigate(['/business']);

  }
}
